// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICoveragePeriodDto } from './ICoveragePeriodDto';
import {
    ICoveragePeriodDtoFromJSON,
    ICoveragePeriodDtoFromJSONTyped,
    ICoveragePeriodDtoToJSON,
    ICoveragePeriodDtoToJSONTyped,
} from './ICoveragePeriodDto';
import type { IPolicyElectionDto } from './IPolicyElectionDto';
import {
    IPolicyElectionDtoFromJSON,
    IPolicyElectionDtoFromJSONTyped,
    IPolicyElectionDtoToJSON,
    IPolicyElectionDtoToJSONTyped,
} from './IPolicyElectionDto';

/**
 * 
 * @export
 * @interface IPolicyEnrollmentDto
 */
export interface IPolicyEnrollmentDto {
    /**
     * 
     * @type {number}
     * @memberof IPolicyEnrollmentDto
     */
    policy_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPolicyEnrollmentDto
     */
    account_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPolicyEnrollmentDto
     */
    plan_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPolicyEnrollmentDto
     */
    plan_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPolicyEnrollmentDto
     */
    plan_code?: string;
    /**
     * 
     * @type {string}
     * @memberof IPolicyEnrollmentDto
     */
    plan_path?: string;
    /**
     * 
     * @type {string}
     * @memberof IPolicyEnrollmentDto
     */
    display_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IPolicyEnrollmentDto
     */
    employee_id?: number;
    /**
     * 
     * @type {Date}
     * @memberof IPolicyEnrollmentDto
     */
    plan_valid_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IPolicyEnrollmentDto
     */
    plan_valid_to?: Date;
    /**
     * 
     * @type {number}
     * @memberof IPolicyEnrollmentDto
     */
    election_amount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPolicyEnrollmentDto
     */
    allow_investments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPolicyEnrollmentDto
     */
    allow_individual_contributions?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IPolicyEnrollmentDto
     */
    investment_threshold?: number;
    /**
     * 
     * @type {number}
     * @memberof IPolicyEnrollmentDto
     */
    minimum_investment_amount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof IPolicyEnrollmentDto
     */
    investment_option_types?: Array<IPolicyEnrollmentDtoInvestmentOptionTypesEnum>;
    /**
     * 
     * @type {string}
     * @memberof IPolicyEnrollmentDto
     */
    account_type?: IPolicyEnrollmentDtoAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IPolicyEnrollmentDto
     */
    enrollment_status?: IPolicyEnrollmentDtoEnrollmentStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof IPolicyEnrollmentDto
     */
    status?: IPolicyEnrollmentDtoStatusEnum;
    /**
     * 
     * @type {Array<ICoveragePeriodDto>}
     * @memberof IPolicyEnrollmentDto
     */
    coverage_periods?: Array<ICoveragePeriodDto>;
    /**
     * 
     * @type {Date}
     * @memberof IPolicyEnrollmentDto
     */
    submit_claims_date_end?: Date;
    /**
     * 
     * @type {string}
     * @memberof IPolicyEnrollmentDto
     */
    proof_of_expenses_type?: IPolicyEnrollmentDtoProofOfExpensesTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IPolicyEnrollmentDto
     */
    proof_of_expenses_card_type?: IPolicyEnrollmentDtoProofOfExpensesCardTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IPolicyEnrollmentDto
     */
    deductible_met?: boolean;
    /**
     * 
     * @type {Set<string>}
     * @memberof IPolicyEnrollmentDto
     */
    deductible_types?: Set<IPolicyEnrollmentDtoDeductibleTypesEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof IPolicyEnrollmentDto
     */
    contribution_monitoring_required?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPolicyEnrollmentDto
     */
    generate_statements?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IPolicyEnrollmentDto
     */
    minimum_contribution_amount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPolicyEnrollmentDto
     */
    cip_required?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IPolicyEnrollmentDto
     */
    catch_up_election?: number;
    /**
     * 
     * @type {number}
     * @memberof IPolicyEnrollmentDto
     */
    catch_up_age?: number;
    /**
     * 
     * @type {number}
     * @memberof IPolicyEnrollmentDto
     */
    current_rollover_remaining?: number;
    /**
     * 
     * @type {number}
     * @memberof IPolicyEnrollmentDto
     */
    prior_rollover_remaining?: number;
    /**
     * 
     * @type {Date}
     * @memberof IPolicyEnrollmentDto
     */
    remaining_rollover_balance_date?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof IPolicyEnrollmentDto
     * @deprecated
     */
    is_replenished?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IPolicyEnrollmentDto
     */
    funding_method_type?: IPolicyEnrollmentDtoFundingMethodTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IPolicyEnrollmentDto
     */
    omnibus_type?: IPolicyEnrollmentDtoOmnibusTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IPolicyEnrollmentDto
     */
    per_pay_employee?: number;
    /**
     * 
     * @type {number}
     * @memberof IPolicyEnrollmentDto
     */
    per_pay_employer?: number;
    /**
     * 
     * @type {Date}
     * @memberof IPolicyEnrollmentDto
     */
    deductible_met_date?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof IPolicyEnrollmentDto
     */
    is_forfeited?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPolicyEnrollmentDto
     */
    is_rollover?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IPolicyEnrollmentDto
     */
    spend_period_type?: IPolicyEnrollmentDtoSpendPeriodTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IPolicyEnrollmentDto
     */
    commuter_limit?: number;
    /**
     * 
     * @type {string}
     * @memberof IPolicyEnrollmentDto
     */
    coverage_tier_type?: IPolicyEnrollmentDtoCoverageTierTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IPolicyEnrollmentDto
     */
    coverage_tier_effective_date?: Date;
    /**
     * 
     * @type {Array<IPolicyElectionDto>}
     * @memberof IPolicyEnrollmentDto
     */
    election_periods?: Array<IPolicyElectionDto>;
    /**
     * 
     * @type {boolean}
     * @memberof IPolicyEnrollmentDto
     */
    is_spend_limit?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum IPolicyEnrollmentDtoInvestmentOptionTypesEnum {
    MANAGED = 'MANAGED',
    SELF_DIRECTED = 'SELF_DIRECTED',
    BROKERAGE = 'BROKERAGE'
}
/**
* @export
* @enum {string}
*/
export enum IPolicyEnrollmentDtoAccountTypeEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}
/**
* @export
* @enum {string}
*/
export enum IPolicyEnrollmentDtoEnrollmentStatusEnum {
    ACTIVE = 'ACTIVE',
    CANCELED = 'CANCELED',
    FUTURE = 'FUTURE',
    EXPIRED = 'EXPIRED'
}
/**
* @export
* @enum {string}
*/
export enum IPolicyEnrollmentDtoStatusEnum {
    ACTIVE = 'ACTIVE',
    CANCELED = 'CANCELED',
    FUTURE = 'FUTURE',
    EXPIRED = 'EXPIRED'
}
/**
* @export
* @enum {string}
*/
export enum IPolicyEnrollmentDtoProofOfExpensesTypeEnum {
    RECEIPT_REQUIRED = 'RECEIPT_REQUIRED',
    NO_RECEIPT_REQUIRED = 'NO_RECEIPT_REQUIRED'
}
/**
* @export
* @enum {string}
*/
export enum IPolicyEnrollmentDtoProofOfExpensesCardTypeEnum {
    RECEIPT_REQUIRED = 'RECEIPT_REQUIRED',
    NO_RECEIPT_REQUIRED = 'NO_RECEIPT_REQUIRED'
}
/**
* @export
* @enum {string}
*/
export enum IPolicyEnrollmentDtoDeductibleTypesEnum {
    INDIVIDUAL_DEDUCTIBLE_MET = 'INDIVIDUAL_DEDUCTIBLE_MET',
    FAMILY_DEDUCTIBLE_MET = 'FAMILY_DEDUCTIBLE_MET'
}
/**
* @export
* @enum {string}
*/
export enum IPolicyEnrollmentDtoFundingMethodTypeEnum {
    STANDARD_NOTIONAL = 'STANDARD_NOTIONAL',
    PREFUND_SPENDDOWN = 'PREFUND_SPENDDOWN',
    PREFUND_AND_CONTRIBUTION = 'PREFUND_AND_CONTRIBUTION',
    CONTRIBUTION_ONLY = 'CONTRIBUTION_ONLY'
}
/**
* @export
* @enum {string}
*/
export enum IPolicyEnrollmentDtoOmnibusTypeEnum {
    HSA = 'HSA',
    NOTIONAL = 'NOTIONAL'
}
/**
* @export
* @enum {string}
*/
export enum IPolicyEnrollmentDtoSpendPeriodTypeEnum {
    UNLIMITED = 'UNLIMITED',
    MONTHLY = 'MONTHLY',
    PLAN_YEAR = 'PLAN_YEAR'
}
/**
* @export
* @enum {string}
*/
export enum IPolicyEnrollmentDtoCoverageTierTypeEnum {
    S = 'S',
    F = 'F',
    EO = 'EO',
    ET = 'ET',
    EC = 'EC',
    ES = 'ES',
    ES1 = 'ES1',
    ES2 = 'ES2',
    ES3 = 'ES3',
    E1 = 'E1',
    E2 = 'E2',
    E3 = 'E3',
    OT = 'OT'
}


/**
 * Check if a given object implements the IPolicyEnrollmentDto interface.
 */
export function instanceOfIPolicyEnrollmentDto(value: object): value is IPolicyEnrollmentDto {
    return true;
}

export function IPolicyEnrollmentDtoFromJSON(json: any): IPolicyEnrollmentDto {
    return IPolicyEnrollmentDtoFromJSONTyped(json, false);
}

export function IPolicyEnrollmentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPolicyEnrollmentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'policy_id': json['policy_id'] == null ? undefined : json['policy_id'],
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
        'plan_id': json['plan_id'] == null ? undefined : json['plan_id'],
        'plan_name': json['plan_name'] == null ? undefined : json['plan_name'],
        'plan_code': json['plan_code'] == null ? undefined : json['plan_code'],
        'plan_path': json['plan_path'] == null ? undefined : json['plan_path'],
        'display_name': json['display_name'] == null ? undefined : json['display_name'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'plan_valid_from': json['plan_valid_from'] == null ? undefined : (new Date(json['plan_valid_from'])),
        'plan_valid_to': json['plan_valid_to'] == null ? undefined : (new Date(json['plan_valid_to'])),
        'election_amount': json['election_amount'] == null ? undefined : json['election_amount'],
        'allow_investments': json['allow_investments'] == null ? undefined : json['allow_investments'],
        'allow_individual_contributions': json['allow_individual_contributions'] == null ? undefined : json['allow_individual_contributions'],
        'investment_threshold': json['investment_threshold'] == null ? undefined : json['investment_threshold'],
        'minimum_investment_amount': json['minimum_investment_amount'] == null ? undefined : json['minimum_investment_amount'],
        'investment_option_types': json['investment_option_types'] == null ? undefined : json['investment_option_types'],
        'account_type': json['account_type'] == null ? undefined : json['account_type'],
        'enrollment_status': json['enrollment_status'] == null ? undefined : json['enrollment_status'],
        'status': json['status'] == null ? undefined : json['status'],
        'coverage_periods': json['coverage_periods'] == null ? undefined : ((json['coverage_periods'] as Array<any>).map(ICoveragePeriodDtoFromJSON)),
        'submit_claims_date_end': json['submit_claims_date_end'] == null ? undefined : (new Date(json['submit_claims_date_end'])),
        'proof_of_expenses_type': json['proof_of_expenses_type'] == null ? undefined : json['proof_of_expenses_type'],
        'proof_of_expenses_card_type': json['proof_of_expenses_card_type'] == null ? undefined : json['proof_of_expenses_card_type'],
        'deductible_met': json['deductible_met'] == null ? undefined : json['deductible_met'],
        'deductible_types': json['deductible_types'] == null ? undefined : new Set(json['deductible_types']),
        'contribution_monitoring_required': json['contribution_monitoring_required'] == null ? undefined : json['contribution_monitoring_required'],
        'generate_statements': json['generate_statements'] == null ? undefined : json['generate_statements'],
        'minimum_contribution_amount': json['minimum_contribution_amount'] == null ? undefined : json['minimum_contribution_amount'],
        'cip_required': json['cip_required'] == null ? undefined : json['cip_required'],
        'catch_up_election': json['catch_up_election'] == null ? undefined : json['catch_up_election'],
        'catch_up_age': json['catch_up_age'] == null ? undefined : json['catch_up_age'],
        'current_rollover_remaining': json['current_rollover_remaining'] == null ? undefined : json['current_rollover_remaining'],
        'prior_rollover_remaining': json['prior_rollover_remaining'] == null ? undefined : json['prior_rollover_remaining'],
        'remaining_rollover_balance_date': json['remaining_rollover_balance_date'] == null ? undefined : (new Date(json['remaining_rollover_balance_date'])),
        'is_replenished': json['is_replenished'] == null ? undefined : json['is_replenished'],
        'funding_method_type': json['funding_method_type'] == null ? undefined : json['funding_method_type'],
        'omnibus_type': json['omnibus_type'] == null ? undefined : json['omnibus_type'],
        'per_pay_employee': json['per_pay_employee'] == null ? undefined : json['per_pay_employee'],
        'per_pay_employer': json['per_pay_employer'] == null ? undefined : json['per_pay_employer'],
        'deductible_met_date': json['deductible_met_date'] == null ? undefined : (new Date(json['deductible_met_date'])),
        'is_forfeited': json['is_forfeited'] == null ? undefined : json['is_forfeited'],
        'is_rollover': json['is_rollover'] == null ? undefined : json['is_rollover'],
        'spend_period_type': json['spend_period_type'] == null ? undefined : json['spend_period_type'],
        'commuter_limit': json['commuter_limit'] == null ? undefined : json['commuter_limit'],
        'coverage_tier_type': json['coverage_tier_type'] == null ? undefined : json['coverage_tier_type'],
        'coverage_tier_effective_date': json['coverage_tier_effective_date'] == null ? undefined : (new Date(json['coverage_tier_effective_date'])),
        'election_periods': json['election_periods'] == null ? undefined : ((json['election_periods'] as Array<any>).map(IPolicyElectionDtoFromJSON)),
        'is_spend_limit': json['is_spend_limit'] == null ? undefined : json['is_spend_limit'],
    };
}

export function IPolicyEnrollmentDtoToJSON(json: any): IPolicyEnrollmentDto {
    return IPolicyEnrollmentDtoToJSONTyped(json, false);
}

export function IPolicyEnrollmentDtoToJSONTyped(value?: IPolicyEnrollmentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'policy_id': value['policy_id'],
        'account_id': value['account_id'],
        'plan_id': value['plan_id'],
        'plan_name': value['plan_name'],
        'plan_code': value['plan_code'],
        'plan_path': value['plan_path'],
        'display_name': value['display_name'],
        'employee_id': value['employee_id'],
        'plan_valid_from': value['plan_valid_from'] == null ? undefined : ((value['plan_valid_from']).toISOString().substring(0,10)),
        'plan_valid_to': value['plan_valid_to'] == null ? undefined : ((value['plan_valid_to']).toISOString().substring(0,10)),
        'election_amount': value['election_amount'],
        'allow_investments': value['allow_investments'],
        'allow_individual_contributions': value['allow_individual_contributions'],
        'investment_threshold': value['investment_threshold'],
        'minimum_investment_amount': value['minimum_investment_amount'],
        'investment_option_types': value['investment_option_types'],
        'account_type': value['account_type'],
        'enrollment_status': value['enrollment_status'],
        'status': value['status'],
        'coverage_periods': value['coverage_periods'] == null ? undefined : ((value['coverage_periods'] as Array<any>).map(ICoveragePeriodDtoToJSON)),
        'submit_claims_date_end': value['submit_claims_date_end'] == null ? undefined : ((value['submit_claims_date_end']).toISOString().substring(0,10)),
        'proof_of_expenses_type': value['proof_of_expenses_type'],
        'proof_of_expenses_card_type': value['proof_of_expenses_card_type'],
        'deductible_met': value['deductible_met'],
        'deductible_types': value['deductible_types'] == null ? undefined : Array.from(value['deductible_types'] as Set<any>),
        'contribution_monitoring_required': value['contribution_monitoring_required'],
        'generate_statements': value['generate_statements'],
        'minimum_contribution_amount': value['minimum_contribution_amount'],
        'cip_required': value['cip_required'],
        'catch_up_election': value['catch_up_election'],
        'catch_up_age': value['catch_up_age'],
        'current_rollover_remaining': value['current_rollover_remaining'],
        'prior_rollover_remaining': value['prior_rollover_remaining'],
        'remaining_rollover_balance_date': value['remaining_rollover_balance_date'] == null ? undefined : ((value['remaining_rollover_balance_date']).toISOString().substring(0,10)),
        'is_replenished': value['is_replenished'],
        'funding_method_type': value['funding_method_type'],
        'omnibus_type': value['omnibus_type'],
        'per_pay_employee': value['per_pay_employee'],
        'per_pay_employer': value['per_pay_employer'],
        'deductible_met_date': value['deductible_met_date'] == null ? undefined : ((value['deductible_met_date']).toISOString().substring(0,10)),
        'is_forfeited': value['is_forfeited'],
        'is_rollover': value['is_rollover'],
        'spend_period_type': value['spend_period_type'],
        'commuter_limit': value['commuter_limit'],
        'coverage_tier_type': value['coverage_tier_type'],
        'coverage_tier_effective_date': value['coverage_tier_effective_date'] == null ? undefined : ((value['coverage_tier_effective_date']).toISOString().substring(0,10)),
        'election_periods': value['election_periods'] == null ? undefined : ((value['election_periods'] as Array<any>).map(IPolicyElectionDtoToJSON)),
        'is_spend_limit': value['is_spend_limit'],
    };
}

